export enum DeployTypes {
  Development = 'dev',
  ReleaseCandidate = 'rc',
  Production = 'prod',
}
